(function(){
  function init(root){
    if(root.dataset.editorialInitialized==='yes')return;
    root.dataset.editorialInitialized='yes';
    var thumbs=Array.from(root.querySelectorAll('[data-editorial-thumb]'));
    var main=root.querySelector('.waqt-editorial__main-image');
    var imageNumber=root.querySelector('[data-editorial-image-number]');
    var dialog=root.querySelector('[data-editorial-dialog]');
    var modalImage=root.querySelector('[data-editorial-modal-photo]');
    var modalCount=root.querySelector('[data-editorial-modal-count]');
    var current=0;

    function showImage(index){
      if(!thumbs.length || !main)return;
      current=(index+thumbs.length)%thumbs.length;
      var t=thumbs[current];
      main.removeAttribute('srcset');main.removeAttribute('sizes');
      main.src=t.dataset.image;main.alt=t.dataset.alt||'WAQT product';
      thumbs.forEach(function(x,i){var active=i===current;x.classList.toggle('is-selected',active);x.setAttribute('aria-pressed',String(active));});
      if(imageNumber)imageNumber.textContent=String(current+1).padStart(2,'0')+' / '+thumbs.length;
      if(modalImage){modalImage.src=t.dataset.image;modalImage.alt=t.dataset.alt||'WAQT product';}
      if(modalCount)modalCount.textContent=(current+1)+' / '+thumbs.length;
    }
    thumbs.forEach(function(t,i){t.addEventListener('click',function(){showImage(i);});});
    var prev=root.querySelector('[data-editorial-main-prev]');
    var next=root.querySelector('[data-editorial-main-next]');
    if(prev)prev.addEventListener('click',function(){showImage(current-1);});
    if(next)next.addEventListener('click',function(){showImage(current+1);});

    function openGallery(){if(!dialog||!modalImage)return;if(thumbs.length)showImage(current);if(typeof dialog.showModal==='function'){dialog.showModal();}else{dialog.setAttribute('open','');}}
    function closeGallery(){if(!dialog)return;if(typeof dialog.close==='function' && dialog.open)dialog.close();else dialog.removeAttribute('open');}
    var openBtn=root.querySelector('[data-editorial-open-gallery]');
    var closeBtn=root.querySelector('[data-editorial-close]');
    var modalPrev=root.querySelector('[data-editorial-modal-prev]');
    var modalNext=root.querySelector('[data-editorial-modal-next]');
    if(openBtn)openBtn.addEventListener('click',openGallery);
    if(main)main.addEventListener('click',openGallery);
    if(closeBtn)closeBtn.addEventListener('click',closeGallery);
    if(modalPrev)modalPrev.addEventListener('click',function(){showImage(current-1);});
    if(modalNext)modalNext.addEventListener('click',function(){showImage(current+1);});
    if(dialog){
      dialog.addEventListener('click',function(event){if(event.target===dialog)closeGallery();});
      dialog.addEventListener('keydown',function(event){
        if(event.key==='ArrowLeft'){event.preventDefault();showImage(current-1);}
        if(event.key==='ArrowRight'){event.preventDefault();showImage(current+1);}
        if(event.key==='Escape'){closeGallery();}
      });
    }
    var options=Array.from(root.querySelectorAll('[data-editorial-variant]'));
    var price=root.querySelector('[data-editorial-price]');
    var savings=root.querySelector('[data-editorial-savings]');
    var compare=root.querySelector('[data-editorial-compare]');
    var cart=root.querySelector('[data-editorial-cart]');
    var cartLabel=root.querySelector('[data-editorial-cart-label]');
    var currentSize=root.querySelector('[data-editorial-current-size]');
    var stock=root.querySelector('[data-editorial-stock]');
    function onVariantChange(input){
      if(!input || input.disabled)return;
      if(currentSize)currentSize.textContent=input.dataset.label||'';
      if(price)price.textContent=input.dataset.price||'';
      if(compare){compare.textContent=input.dataset.compare||'';compare.hidden=!input.dataset.compare;}
      if(savings){savings.textContent=input.dataset.savings||'';savings.hidden=!input.dataset.savings;}
      var available=input.dataset.available==='true';
      if(cart)cart.disabled=!available;
      if(cartLabel)cartLabel.textContent=available?'ADD TO CART':'SOLD OUT';
      if(stock)stock.textContent=available?'':'This size is currently unavailable';
      var url=new URL(window.location.href);
      url.searchParams.set('variant',input.value);
      history.replaceState({},'',url.toString());
    }
    options.forEach(function(input){input.addEventListener('change',function(){if(input.checked)onVariantChange(input);});});
    var sizeGuide=root.querySelector('[data-editorial-guide-dialog]');
    var openGuides=root.querySelectorAll('[data-editorial-open-guide]');
    var closeGuide=root.querySelector('[data-editorial-close-guide]');
    openGuides.forEach(function(btn){
      btn.addEventListener('click',function(){
        if(!sizeGuide)return;
        if(typeof sizeGuide.showModal==='function')sizeGuide.showModal();
        else sizeGuide.setAttribute('open','');
      });
    });
    if(closeGuide)closeGuide.addEventListener('click',function(){
      if(sizeGuide && typeof sizeGuide.close==='function')sizeGuide.close();
      else if(sizeGuide)sizeGuide.removeAttribute('open');
    });
    if(sizeGuide)sizeGuide.addEventListener('click',function(ev){
      if(ev.target===sizeGuide){
        if(typeof sizeGuide.close==='function')sizeGuide.close();
        else sizeGuide.removeAttribute('open');
      }
    });
    var waitlistSize=root.querySelector('[data-editorial-waitlist-size]');
    var waitlistTags=root.querySelector('[data-editorial-waitlist-tags]');
    if(waitlistSize && waitlistTags){
      function updateWaitlistTags(){
        var selected=waitlistSize.value.replace(/[^A-Za-z0-9]/g,'').toUpperCase();
        waitlistTags.value='WAQT_RESTOCK_'+(waitlistTags.dataset.restockProduct||'PRODUCT')+',WAQT_SIZE_'+selected;
      }
      waitlistSize.addEventListener('change',updateWaitlistTags);
      updateWaitlistTags();
    }

    /* Stay on the product page, add the selected size through Shopify's Ajax cart. */
    var form=root.querySelector('.waqt-editorial__form');
    var cartLink=document.querySelector('[data-waqt-header-cart]');
    var formButton=root.querySelector('[data-editorial-cart]');
    var formLabel=root.querySelector('[data-editorial-cart-label]');
    var productName=root.dataset.productTitle||'WAQT T-shirt';
    var cartRoot=root.dataset.cartRoot||'/';

    function animateAddedToCart(){
      if(!cartLink)return;
      cartLink.classList.remove('waqt-cart-icon--bump');
      void cartLink.offsetWidth;
      cartLink.classList.add('waqt-cart-icon--bump');
      setTimeout(function(){cartLink.classList.remove('waqt-cart-icon--bump');},650);
      if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      var start=formButton&&formButton.getBoundingClientRect();
      var finish=cartLink.getBoundingClientRect();
      var productPhoto=main;
      if(!start||!productPhoto||!productPhoto.currentSrc&&!productPhoto.src)return;
      var flying=document.createElement('img');
      flying.src=productPhoto.currentSrc||productPhoto.src;
      flying.alt='';
      flying.setAttribute('aria-hidden','true');
      flying.className='waqt-cart-flying-image';
      flying.style.left=(start.left+start.width/2-25)+'px';
      flying.style.top=(start.top+start.height/2-25)+'px';
      document.body.appendChild(flying);
      var deltaX=(finish.left+finish.width/2)-(start.left+start.width/2);
      var deltaY=(finish.top+finish.height/2)-(start.top+start.height/2);
      if(typeof flying.animate==='function'){
        var animation=flying.animate([
          {transform:'translate3d(0,0,0) scale(1)',opacity:1},
          {transform:'translate3d('+deltaX+'px,'+deltaY+'px,0) scale(.26)',opacity:.35}
        ],{duration:620,easing:'cubic-bezier(.18,.7,.3,1)'});
        animation.onfinish=function(){flying.remove();};
        animation.oncancel=function(){flying.remove();};
      }else flying.remove();
    }
    function showCartToast(message,isError){
      var old=document.querySelector('[data-waqt-cart-toast]');
      if(old)old.remove();
      var toast=document.createElement('div');
      toast.className='waqt-cart-toast'+(isError?' waqt-cart-toast--error':'');
      toast.setAttribute('data-waqt-cart-toast','');
      toast.setAttribute('role',isError?'alert':'status');
      var inner=document.createElement('div');
      inner.className='waqt-cart-toast__text';
      var heading=document.createElement('strong');
      heading.textContent=isError?'COULD NOT ADD TO BAG':'ADDED TO YOUR BAG ✓';
      var description=document.createElement('span');
      description.textContent=message;
      inner.append(heading,description);
      var actions=document.createElement('div');
      actions.className='waqt-cart-toast__actions';
      if(!isError){
        var view=document.createElement('a');
        view.href=root.dataset.cartLink||'/cart';
        view.textContent='VIEW BAG ↗';
        actions.appendChild(view);
      }
      var dismiss=document.createElement('button');
      dismiss.type='button';
      dismiss.textContent='✕';
      dismiss.setAttribute('aria-label','Dismiss cart message');
      dismiss.addEventListener('click',function(){toast.remove();});
      actions.appendChild(dismiss);
      toast.append(inner,actions);
      document.body.appendChild(toast);
      setTimeout(function(){if(toast.isConnected)toast.remove();},4600);
    }
    if(form && formButton){
      var buyNowButton=root.querySelector('[data-editorial-buy-now]');
      var buyingNow=false;
      if(buyNowButton)buyNowButton.addEventListener('click',function(){buyingNow=true;});
      var adding=false;
      form.addEventListener('submit',async function(event){
        if(typeof window.fetch!=='function'||typeof window.FormData!=='function')return;
        event.preventDefault();
        if(adding)return;
        var selected=form.querySelector('input[name="id"]:checked')||form.querySelector('input[name="id"][type="hidden"]');
        if(!selected || selected.disabled){
          showCartToast('Please select an available size.',true);
          return;
        }
        adding=true;
        formButton.disabled=true;
        if(formLabel)formLabel.textContent='ADDING…';
        var itemQuantity=Number((form.querySelector('[name="quantity"]')||{}).value)||1;
        try{
          var response=await fetch(cartRoot+'cart/add.js',{
            method:'POST',headers:{'Accept':'application/json'},credentials:'same-origin',
            body:new FormData(form)
          });
          var added=await response.json().catch(function(){return {};});
          if(!response.ok)throw new Error(added.description||added.message||'Could not add this size. Please try again.');
          /* The cart badge should reflect Shopify's actual item_count, not a guess. */
          try{
            var countResponse=await fetch(cartRoot+'cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}});
            if(countResponse.ok){
              var state=await countResponse.json();
              var badge=document.querySelector('[data-waqt-cart-count]');
              if(badge && Number.isFinite(Number(state.item_count))){
                badge.textContent=String(state.item_count);
                badge.hidden=state.item_count===0;
              }
              if(cartLink && Number.isFinite(Number(state.item_count)))cartLink.setAttribute('aria-label','Cart, '+state.item_count+' items');
            }
          }catch(ignored){}
          if(buyingNow){window.location.href=cartRoot+'checkout';return;}
          animateAddedToCart();
          var size=selected.dataset.label||'';
          if(window.waqtOpenPreorderDrawer){window.waqtOpenPreorderDrawer();}
          else showCartToast(itemQuantity+' × '+productName+(size?' · Size '+size:'')+'. Continue exploring or view your bag.',false);
        }catch(err){
          showCartToast(err.message||'There was a problem adding this tee.',true);
        }finally{
          adding=false;
          buyingNow=false;
          formButton.disabled=selected.dataset.available==='false';
          if(formLabel)formLabel.textContent=formButton.disabled?'SOLD OUT':'ADD TO CART';
        }
      });
    }

    /* Serviceability is based on an explicitly configured exact-PIN whitelist.
       Do not claim coverage when the merchant has not supplied verified PIN codes. */
    var pinForm=root.querySelector('[data-editorial-pincode-form]');
    if(pinForm){
      var pinInput=pinForm.querySelector('[data-editorial-pin-input]');
      var pinMessage=root.querySelector('[data-editorial-pin-message]');
      var approved=new Set((pinForm.dataset.supportedPincodes||'').split(/[\s,;]+/).filter(function(s){return /^\d{6}$/.test(s);}));
      pinInput.addEventListener('input',function(){pinInput.value=pinInput.value.replace(/\D/g,'').slice(0,6);if(pinMessage){pinMessage.textContent='';pinMessage.removeAttribute('data-state');}});
      pinForm.addEventListener('submit',function(event){
        event.preventDefault();
        var pin=pinInput.value.trim();
        var result='',statusType='neutral';
        if(!/^\d{6}$/.test(pin)){result='Please enter a valid six-digit PIN code.';statusType='error';}
        else if(pinForm.dataset.deliveryMode!=='verified'){
          result='We currently ship across India, including orders to this PIN code under our nationwide policy. Final courier serviceability will be confirmed by our shipping partner.';
          statusType='success';
        }
        else if(!approved.size){result='Verified delivery PIN codes are not configured yet. Please contact WAQT before placing an order.';statusType='neutral';}
        else if(approved.has(pin)){result='This PIN code is on our verified delivery list. Final confirmation is subject to our courier partner.';statusType='success';}
        else{result='This PIN code is not on our current delivery list. Contact WAQT for assistance.';statusType='error';}
        if(pinMessage){pinMessage.textContent=result;pinMessage.dataset.state=statusType;}
      });
    }

    var qty=root.querySelector('[data-editorial-quantity]');
    if(qty){
      var normalize=function(n){return Math.max(1,Math.min(10,Number.isFinite(n)?Math.floor(n):1));};
      var minus=root.querySelector('[data-editorial-minus]');
      var plus=root.querySelector('[data-editorial-plus]');
      if(minus)minus.addEventListener('click',function(){qty.value=normalize(Number(qty.value)-1);});
      if(plus)plus.addEventListener('click',function(){qty.value=normalize(Number(qty.value)+1);});
      qty.addEventListener('change',function(){qty.value=normalize(Number(qty.value));});
    }
  }
  function start(){document.querySelectorAll('[data-editorial-page]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();